import React, { Suspense, useEffect, useState } from 'react';
import './hero.css';
import { shouldAnimate } from './shouldAnimate';
import { StaticHeroLayers } from './StaticHero';
import { HeroContent, type HeroContentProps } from './HeroContent';

const CosmicHeroLayers = React.lazy(() => import('./CosmicHero'));

/**
 * The hero section + content render once and stay mounted. Only the BACKGROUND
 * layers swap from static → animated after an idle check (and lazy load), so the
 * title / subtitle / CTAs never remount and their entrance animation never
 * replays (previously the whole hero swapped, which caused a flicker).
 */
export const Hero: React.FC<HeroContentProps> = (props) => {
  const [animate, setAnimate] = useState<boolean | null>(null);

  useEffect(() => {
    const decide = () => setAnimate(shouldAnimate());
    const idle = window.requestIdleCallback
      ? window.requestIdleCallback(decide, { timeout: 300 })
      : window.setTimeout(decide, 150);
    return () => {
      if (window.cancelIdleCallback) window.cancelIdleCallback(idle);
      else window.clearTimeout(idle);
    };
  }, []);

  return (
    <section className="hero" role="banner">
      {animate ? (
        <Suspense fallback={<StaticHeroLayers />}>
          <CosmicHeroLayers />
        </Suspense>
      ) : (
        <StaticHeroLayers />
      )}
      <HeroContent {...props} />
    </section>
  );
};

export default Hero;
